import React, {VoidFunctionComponent} from "react";

export const Description: VoidFunctionComponent<{ description: string }> = ({description}) => {
    return (
        <div
            className='description-layer' id='description-layer'
            dangerouslySetInnerHTML={{__html: description}}
        />
    );
};
